import { useState, useEffect } from 'react';
import { getFaq, envoyerRetour } from '../api';
import { APP_VERSION } from '../version';

/*
 * Aide : questions fréquentes, puis « Nous contacter ».
 *  - un problème avec l'application → l'équipe d'Équipote, avec le contexte utile ;
 *  - une question pour mon club → la direction et le coach du club, par email.
 */
const champ = { width: '100%', boxSizing: 'border-box', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 9, color: 'var(--text)', padding: '9px 11px', fontSize: 14 };
const sansAccents = s => String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

function Contact({ avecClub, page }) {
  const [type, setType] = useState(null);
  const [message, setMessage] = useState('');
  const [capture, setCapture] = useState(null);
  const [etat, setEtat] = useState(null);      // null | 'envoi' | 'envoye' | message d'erreur
  if (etat === 'envoye') return (
    <div role="status" style={{ border: '1px solid #22c55e', borderRadius: 11, padding: '12px 14px', fontSize: 13.5, lineHeight: 1.5 }}>
      ✓ {type === 'club'
        ? 'Votre question a été transmise à la direction et au coach de votre club. Ils vous répondront par email.'
        : 'Merci, votre signalement nous est parvenu. Nous vous répondrons par email si besoin.'}
    </div>);
  const choix = [['probleme', '🛠️ Un problème avec l\'application', 'Un bug, une page qui ne s\'ouvre pas : il arrive directement à l\'équipe d\'Équipote.'],
                 ...(avecClub ? [['club', '🏛️ Une question pour mon club', 'Une convocation, une équipe, un compte : elle va à la direction et au coach de votre club.']] : [])];
  const envoyer = async e => {
    e.preventDefault(); setEtat('envoi');
    try {
      await envoyerRetour({ type, message, capture: type === 'probleme' ? capture : null, page, version: APP_VERSION,
                            ecran: `${window.innerWidth}x${window.innerHeight}` });
      setEtat('envoye');
    } catch (x) { setEtat(x.message); }
  };
  return (
    <form onSubmit={envoyer}>
      <div style={{ display: 'grid', gap: 7, marginBottom: 10 }}>
        {choix.map(([k, titre, detail]) => (
          <button key={k} type="button" aria-pressed={type === k} onClick={() => setType(k)}
                  style={{ textAlign: 'left', cursor: 'pointer', color: 'var(--text)', borderRadius: 10, padding: '9px 12px',
                           background: type === k ? 'rgba(var(--accent-rgb),0.12)' : 'transparent', border: `1px solid ${type === k ? 'var(--accent)' : 'var(--border)'}` }}>
            <div style={{ fontWeight: 700, fontSize: 13.5 }}>{titre}</div>
            <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>{detail}</div>
          </button>))}
      </div>
      {type && (<>
        <textarea style={{ ...champ, minHeight: 100, fontFamily: 'inherit' }} required minLength={5} maxLength={3000} value={message}
                  aria-label="Votre message" placeholder={type === 'club' ? 'Votre question…' : 'Décrivez ce qui se passe, et ce que vous faisiez à ce moment-là…'}
                  onChange={e => setMessage(e.target.value)} />
        {type === 'probleme' && (
          <label style={{ display: 'block', fontSize: 12, color: 'var(--muted)', margin: '8px 0' }}>Une capture d'écran (facultatif)
            <input type="file" accept="image/jpeg,image/png,image/webp" style={{ display: 'block', marginTop: 5 }} onChange={e => setCapture(e.target.files[0] || null)} />
          </label>)}
        {etat && etat !== 'envoi' && <div style={{ color: 'var(--danger)', fontSize: 13, margin: '6px 0' }}>{etat}</div>}
        <button className="btn btn-primary" disabled={etat === 'envoi'} style={{ marginTop: 8 }}>{etat === 'envoi' ? 'Envoi…' : 'Envoyer'}</button>
      </>)}
    </form>);
}

export default function Aide({ onFermer, connecte, avecClub, page, onRevoirVisite, onSupprimerCompte }) {
  const [faq, setFaq] = useState(null);
  const [recherche, setRecherche] = useState('');
  const [ouverte, setOuverte] = useState(null);
  useEffect(() => { getFaq().then(r => setFaq(r.faq)).catch(() => setFaq([])); }, []);
  useEffect(() => { const esc = e => e.key === 'Escape' && onFermer(); window.addEventListener('keydown', esc); return () => window.removeEventListener('keydown', esc); }, [onFermer]);
  const r = sansAccents(recherche.trim());
  const liste = (faq || []).filter(q => !r || sansAccents(q.question + ' ' + q.reponse).includes(r));
  return (
    <div role="dialog" aria-modal="true" aria-label="Aide" onClick={e => e.target === e.currentTarget && onFermer()}
         style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.65)', zIndex: 4000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
      <div style={{ background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: '16px 16px 0 0', width: '100%', maxWidth: 560, maxHeight: '88vh', overflowY: 'auto', padding: '18px 18px 26px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <div style={{ fontSize: 19, fontWeight: 800 }}>❓ Aide</div>
          <button onClick={onFermer} aria-label="Fermer" style={{ background: 'none', border: 'none', color: 'var(--muted)', fontSize: 22, cursor: 'pointer' }}>×</button>
        </div>
        <input type="search" style={{ ...champ, marginBottom: 10 }} placeholder="Rechercher : mot de passe, notifications…" aria-label="Rechercher dans l'aide"
               value={recherche} onChange={e => setRecherche(e.target.value)} />
        {!faq && <div style={{ color: 'var(--muted)', fontSize: 13 }}>Chargement…</div>}
        {faq && liste.length === 0 && <div style={{ color: 'var(--muted)', fontSize: 13, marginBottom: 10 }}>Aucune réponse ne correspond : écrivez-nous ci-dessous.</div>}
        {liste.map(q => (
          <div key={q.id} style={{ borderBottom: '1px solid var(--border)' }}>
            <button type="button" aria-expanded={ouverte === q.id} onClick={() => setOuverte(ouverte === q.id ? null : q.id)}
                    style={{ all: 'unset', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', gap: 10, width: '100%', padding: '11px 2px', fontSize: 14, fontWeight: 600 }}>
              <span>{q.question}</span><span style={{ color: 'var(--accent)' }}>{ouverte === q.id ? '▾' : '▸'}</span>
            </button>
            {ouverte === q.id && <div style={{ fontSize: 13.5, color: 'var(--muted)', lineHeight: 1.55, padding: '0 2px 12px', whiteSpace: 'pre-line' }}>{q.reponse}</div>}
          </div>))}
        {onRevoirVisite && (
          <button type="button" onClick={onRevoirVisite} style={{ marginTop: 14, background: 'none', border: 'none', color: 'var(--accent)', cursor: 'pointer', fontSize: 13.5, fontWeight: 700, padding: 0 }}>
            🧭 Revoir la visite de l'application</button>)}
        <div style={{ fontSize: 15, fontWeight: 800, margin: '20px 0 10px' }}>Nous contacter</div>
        {connecte
          ? <Contact avecClub={avecClub} page={page} />
          : <div style={{ fontSize: 13.5, color: 'var(--muted)', lineHeight: 1.5 }}>Écrivez-nous à <a href="mailto:contact@equipote.fr">contact@equipote.fr</a>. Une fois connecté, vous pourrez aussi nous signaler un problème depuis cette page.</div>}
        {onSupprimerCompte && (
          <div style={{ marginTop: 22, paddingTop: 14, borderTop: '1px solid var(--border)' }}>
            <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 6 }}>Mon compte</div>
            <button type="button" onClick={onSupprimerCompte}
                    style={{ background: 'none', border: 'none', color: 'var(--danger)', cursor: 'pointer', fontSize: 13.5, fontWeight: 700, padding: 0 }}>
              Supprimer mon compte</button>
          </div>)}
      </div>
    </div>);
}
